import { ValidationErrors } from 'final-form';
import React from 'react';
import { useIntl } from 'react-intl';

import { FieldInput } from '../../ui';
import { StorageFieldLinks } from './settings';
import { CustomFieldsWrapper } from './style';

type Props = {
  errors: ValidationErrors;
};

const FirebaseFields = ({ errors }: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <CustomFieldsWrapper>
      <CustomFieldsWrapper>
        <FieldInput
          name="firebase_apikey"
          placeholder="F1817B06A4521103"
          label={
            intl.messages[`user-data-base.settings.user-storage.firebase.firebase_apikey.label`]
          }
          extraLink={{
            title:
              intl.messages[`user-data-base.settings.user-storage.firebase.firebase_apikey.link`],
            to: StorageFieldLinks.firebase_apikey
          }}
          errorMessage={intl.messages[errors?.firebase_apikey] as string}
        />
      </CustomFieldsWrapper>
    </CustomFieldsWrapper>
  );
};

export default FirebaseFields;
